import { ConsultationResponse } from 'types';
import { GetResponsesResponse } from '../responses';
import { GetResponsesConsultationResponse } from '../responses/types/GetResponsesConsultationResponse';
import { GetResponsesConsultationResponseAnswer } from '../responses/types/GetResponsesConsultationResponseAnswer';
import { MOCK_ORGANISATIONS } from './mockTeamData';

export const MOCK_RESPONSE_PAST_RESPONSE_DOCUMENT = {
  id: 1,
  responseId: 1,
  name: 'content response details.doc',
  dateCreated: new Date('2021-06-06'),
  dateModified: new Date('2021-06-06'),
  response: true,
};

export const MOCK_RESPONSE_PAST_RESPONSE: ConsultationResponse = {
  id: 1,
  consultationId: 1,
  consulteeId: 1,
  response: 'Test response',
  responseTypeId: 1,
  responseType: 'Consulted in error',
  dateCreated: new Date('2022-02-02'),
  referenceNumber: 'CHR-1',
  submittedDate: new Date('2022-02-02'),
  documents: [MOCK_RESPONSE_PAST_RESPONSE_DOCUMENT],
  answers: [],
};

export const MOCK_RESPONSE_PAST_RESPONSES: ConsultationResponse[] = [
  MOCK_RESPONSE_PAST_RESPONSE,
  {
    ...MOCK_RESPONSE_PAST_RESPONSE,
    id: 2,
    referenceNumber: 'CHR-2',
  },
  {
    ...MOCK_RESPONSE_PAST_RESPONSE,
    id: 3,
    referenceNumber: 'CHR-3',
  },
  {
    ...MOCK_RESPONSE_PAST_RESPONSE,
    id: 4,
    referenceNumber: 'CHR-4',
  },
  {
    ...MOCK_RESPONSE_PAST_RESPONSE,
    id: 5,
    referenceNumber: 'CHR-5',
    submittedDate: undefined,
    documents: [],
  },
];

export const MOCK_RESPONSE_ANSWER: GetResponsesConsultationResponseAnswer = {
  id: 1,
  responseId: 2,
  consulteeId: 1,
  consulteeName: 'Tom Kazansky',
  questionId: 1,
  question: 'You can be my wingman anytime',
  answer: 'Because you are dangerous',
  approved: true,
  questionNumber: 101,
  dateCreated: new Date('2022-02-02'),
  organisation: MOCK_ORGANISATIONS[0],
};

export const MOCK_CONSULTATION_RESPONSE: GetResponsesConsultationResponse = {
  id: 11,
  consultationId: 1,
  consulteeId: 1,
  responseTypeId: 1,
  responseType: 'Consulted in error',
  response: 'Test response other answer',
  referenceNumber: 'CHR-1',
  dateCreated: new Date('2022-02-02'),
  submittedDate: new Date('2022-02-02'),
  documents: [MOCK_RESPONSE_PAST_RESPONSE_DOCUMENT],
  answers: [MOCK_RESPONSE_ANSWER],
};

export const MOCK_RESPONSES_RESPONSE: GetResponsesResponse = {
  responses: [],
  otherResponses: [MOCK_CONSULTATION_RESPONSE],
};

export const MOCK_RESPONSES_RESPONSE_WITH_PAST: GetResponsesResponse = {
  responses: MOCK_RESPONSE_PAST_RESPONSES as GetResponsesConsultationResponse[],
  otherResponses: [MOCK_CONSULTATION_RESPONSE],
};

export const EMPTY_MOCK_RESPONSES_RESPONSE: GetResponsesResponse = {
  responses: [],
  otherResponses: [],
};
